import Item from "./Item";
import Site from "./Site";

export default class StockDemand {
  constructor(
    public site: Site,
    public item: Item,
    public quantity: number,
    public minQuantity: number,
    public maxQuantity: number,
    public orderedQuantity: number,
    public deliveredQuantity: number,
    public stockQuantity: number,
    public stockLevelId: number,
    public minQuantityBreachedAt: string | undefined,
    public maxQuantityReachedAt: string | undefined,
  ) {
    this.recalculate();
  }

  deliveryFulfilled: boolean = false;
  deliveryPartiallyFulfilled: boolean = false;
  canRefill: boolean = false;
  hasDemand: boolean = false;
  shownQuanity: number = 0;

  public recalculate = () => {
    if (this.quantity <= 0) {
      this.shownQuanity = 0;
    }
    else {
      this.shownQuanity = this.quantity;
    }
    this.quantity = this.maxQuantity - this.stockQuantity;
    this.hasDemand = this.stockQuantity < this.minQuantity;
    this.deliveryFulfilled = this.deliveredQuantity + this.orderedQuantity >= this.maxQuantity - this.stockQuantity;
    this.deliveryPartiallyFulfilled = this.deliveredQuantity + this.orderedQuantity > this.minQuantity - this.stockQuantity;
    this.canRefill = this.maxQuantity > this.stockQuantity + this.deliveredQuantity + this.orderedQuantity;
  }
}
